/**
 * Nature's Luxury - theme scripts
 */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {

    // ============================
    // Mobile Menu Drawer
    // ============================
    var mobileToggle = document.querySelector('.mobile-toggle');
    var mobileDrawer = document.getElementById('mobile-drawer');
    var mobileOverlay = document.getElementById('mobile-drawer-overlay');
    var mobileClose = document.getElementById('mobile-drawer-close');

    function openMobileDrawer() {
      if (mobileDrawer) { mobileDrawer.classList.add('is-open'); }
      if (mobileOverlay) { mobileOverlay.classList.add('is-visible'); }
      document.body.style.overflow = 'hidden';
    }
    function closeMobileDrawer() {
      if (mobileDrawer) { mobileDrawer.classList.remove('is-open'); }
      if (mobileOverlay) { mobileOverlay.classList.remove('is-visible'); }
      document.body.style.overflow = '';
    }

    if (mobileToggle) { mobileToggle.addEventListener('click', openMobileDrawer); }
    if (mobileClose) { mobileClose.addEventListener('click', closeMobileDrawer); }
    if (mobileOverlay) { mobileOverlay.addEventListener('click', closeMobileDrawer); }

    // Mobile submenu toggles
    document.querySelectorAll('.mobile-submenu-toggle').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        this.classList.toggle('is-open');
        var submenu = this.nextElementSibling;
        if (submenu) submenu.classList.toggle('is-open');
      });
    });

    // ============================
    // Cart Drawer
    // ============================
    var cartDrawer = document.getElementById('cart-drawer');
    var cartOverlay = document.getElementById('cart-drawer-overlay');
    var cartClose = document.getElementById('cart-drawer-close');

    function openCartDrawer() {
      if (cartDrawer) { cartDrawer.classList.add('is-open'); }
      if (cartOverlay) { cartOverlay.classList.add('is-visible'); }
      document.body.style.overflow = 'hidden';
    }
    function closeCartDrawer() {
      if (cartDrawer) { cartDrawer.classList.remove('is-open'); }
      if (cartOverlay) { cartOverlay.classList.remove('is-visible'); }
      document.body.style.overflow = '';
    }

    window.openCartDrawer = openCartDrawer;
    if (cartClose) { cartClose.addEventListener('click', closeCartDrawer); }
    if (cartOverlay) { cartOverlay.addEventListener('click', closeCartDrawer); }

    // Cart icon click - open drawer or go to cart page
    var cartLink = document.querySelector('.header-icons a[href="/cart"]');
    if (cartLink && window.cartType === 'drawer') {
      cartLink.addEventListener('click', function(e) {
        e.preventDefault();
        refreshCartDrawer();
        openCartDrawer();
      });
    }

    window.refreshCartDrawer = function() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var itemsEl = document.getElementById('cart-drawer-items');
          var emptyEl = document.getElementById('cart-drawer-empty');
          var footerEl = document.getElementById('cart-drawer-footer');
          var totalEl = document.getElementById('cart-drawer-total');

          if (!itemsEl) return;

          if (cart.item_count === 0) {
            if (emptyEl) emptyEl.style.display = '';
            if (footerEl) footerEl.style.display = 'none';
            // Remove existing items
            itemsEl.querySelectorAll('.cart-drawer-item').forEach(function(el) { el.remove(); });
            return;
          }

          if (emptyEl) emptyEl.style.display = 'none';
          if (footerEl) footerEl.style.display = '';
          if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

          // Remove old items
          itemsEl.querySelectorAll('.cart-drawer-item').forEach(function(el) { el.remove(); });

          cart.items.forEach(function(item, idx) {
            var div = document.createElement('div');
            div.className = 'cart-drawer-item';
            var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-drawer-item-variant">' + item.variant_title + '</div>' : '';
            div.innerHTML = '<img src="' + (item.image ? item.image.replace(/(\.\w+)$/, '_160x$1') : '') + '" alt="' + item.title + '">' +
              '<div class="cart-drawer-item-info">' +
              '<div class="cart-drawer-item-title">' + item.product_title + '</div>' +
              variantTitle +
              '<div class="cart-drawer-item-bottom">' +
              '<div class="cart-drawer-item-qty">' +
              '<button data-line="' + (idx + 1) + '" data-delta="-1">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button data-line="' + (idx + 1) + '" data-delta="1">+</button>' +
              '</div>' +
              '<div class="cart-drawer-item-price">' + formatMoney(item.line_price) + '</div>' +
              '</div></div>';

            div.querySelectorAll('.cart-drawer-item-qty button').forEach(function(btn) {
              btn.addEventListener('click', function() {
                var line = parseInt(this.getAttribute('data-line'));
                var delta = parseInt(this.getAttribute('data-delta'));
                var currentQty = item.quantity + delta;
                if (currentQty < 0) currentQty = 0;
                fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ line: line, quantity: currentQty })
                }).then(function() { refreshCartDrawer(); updateCartCount(); });
              });
            });

            itemsEl.appendChild(div);
          });

          // Update header cart count
          updateCartCount(cart.item_count);
        });
    };

    function updateCartCount(count) {
      if (count === undefined) {
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) { setCount(c.item_count); });
      } else {
        setCount(count);
      }
    }
    function setCount(n) {
      document.querySelectorAll('.cart-count').forEach(function(el) {
        el.textContent = n;
        el.style.display = n > 0 ? '' : 'none';
      });
    }

    // ============================
    // Mega Menu
    // ============================
    var megaPanels = document.querySelectorAll('.mega-menu-panel');
    var menuLinks = document.querySelectorAll('.main-navigation .menu > li > a');
    var megaTimeout;

    function closeAllMega() {
      megaPanels.forEach(function(p) { p.classList.remove('is-active'); });
      menuLinks.forEach(function(l) { l.classList.remove('mega-active'); });
    }

    function findPanel(triggerText) {
      var slug = triggerText.toLowerCase().trim().replace(/\s+/g, '-');
      var panel = null;
      megaPanels.forEach(function(p) {
        if (p.getAttribute('data-mega-trigger') === slug) panel = p;
      });
      return panel;
    }

    menuLinks.forEach(function(link) {
      link.addEventListener('mouseenter', function() {
        clearTimeout(megaTimeout);
        var panel = findPanel(this.textContent);
        if (panel) { closeAllMega(); panel.classList.add('is-active'); this.classList.add('mega-active'); }
      });
    });

    var header = document.querySelector('.site-header');
    if (header) {
      header.addEventListener('mouseleave', function() { megaTimeout = setTimeout(closeAllMega, 150); });
      megaPanels.forEach(function(panel) {
        panel.addEventListener('mouseenter', function() { clearTimeout(megaTimeout); });
        panel.addEventListener('mouseleave', function() { megaTimeout = setTimeout(closeAllMega, 150); });
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeAllMega();
        closeMobileDrawer();
        closeCartDrawer();
        var sf = document.querySelector('.header-search-form');
        if (sf) sf.classList.remove('is-visible');
        var ps = document.getElementById('predictive-search-results');
        if (ps) ps.classList.remove('is-visible');
        closeSizeGuide();
      }
    });

    // ============================
    // Search + Predictive Search
    // ============================
    var searchToggle = document.querySelector('.search-toggle');
    var searchClose = document.querySelector('.search-close');
    var searchForm = document.querySelector('.header-search-form');
    var searchInput = searchForm ? searchForm.querySelector('input[type="search"]') : null;
    var predictiveResults = document.getElementById('predictive-search-results');
    var searchTimeout;

    if (searchToggle && searchForm) {
      searchToggle.addEventListener('click', function() {
        searchForm.classList.toggle('is-visible');
        if (searchForm.classList.contains('is-visible') && searchInput) searchInput.focus();
      });
    }
    if (searchClose && searchForm) {
      searchClose.addEventListener('click', function() {
        searchForm.classList.remove('is-visible');
        if (predictiveResults) predictiveResults.classList.remove('is-visible');
      });
    }

    if (searchInput && predictiveResults) {
      searchInput.addEventListener('input', function() {
        clearTimeout(searchTimeout);
        var query = this.value.trim();
        if (query.length < 2) {
          predictiveResults.classList.remove('is-visible');
          return;
        }
        searchTimeout = setTimeout(function() {
          fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,article,page&resources[limit]=6')
            .then(function(r) { return r.json(); })
            .then(function(data) {
              var html = '<div class="predictive-search-inner">';
              var resources = data.resources && data.resources.results;
              var hasResults = false;

              if (resources && resources.products && resources.products.length) {
                hasResults = true;
                html += '<h4>Products</h4>';
                resources.products.forEach(function(p) {
                  html += '<a href="' + p.url + '" class="predictive-result">';
                  if (p.image) html += '<img src="' + p.image + '" alt="' + p.title + '">';
                  html += '<div class="predictive-result-info"><div class="predictive-result-title">' + p.title + '</div><div class="predictive-result-price">' + p.price + '</div></div></a>';
                });
              }
              if (resources && resources.articles && resources.articles.length) {
                hasResults = true;
                html += '<h4>Articles</h4>';
                resources.articles.forEach(function(a) {
                  html += '<a href="' + a.url + '" class="predictive-result"><div class="predictive-result-info"><div class="predictive-result-title">' + a.title + '</div></div></a>';
                });
              }
              if (resources && resources.pages && resources.pages.length) {
                hasResults = true;
                html += '<h4>Pages</h4>';
                resources.pages.forEach(function(pg) {
                  html += '<a href="' + pg.url + '" class="predictive-result"><div class="predictive-result-info"><div class="predictive-result-title">' + pg.title + '</div></div></a>';
                });
              }

              if (hasResults) {
                html += '<a href="/search?q=' + encodeURIComponent(query) + '" class="predictive-search-link">View all results →</a>';
              } else {
                html += '<p style="text-align:center;padding:24px;color:var(--color-text-light);">No results found</p>';
              }
              html += '</div>';
              predictiveResults.innerHTML = html;
              predictiveResults.classList.add('is-visible');
            })
            .catch(function() {
              predictiveResults.classList.remove('is-visible');
            });
        }, 300);
      });
    }

    // ============================
    // Collection Filters
    // ============================
    var filterToggle = document.getElementById('filter-toggle');
    var filterPanel = document.getElementById('collection-filters');
    var filterClose = document.getElementById('filter-close');

    if (filterToggle && filterPanel) {
      filterToggle.addEventListener('click', function() {
        filterPanel.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    }
    if (filterClose && filterPanel) {
      filterClose.addEventListener('click', function() {
        filterPanel.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }

    document.querySelectorAll('.filter-group-toggle').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var targetId = this.getAttribute('data-target');
        var content = document.getElementById(targetId);
        if (content) content.classList.toggle('is-open');
        this.querySelector('svg').style.transform = content && content.classList.contains('is-open') ? '' : 'rotate(-90deg)';
      });
    });

    // ============================
    // Product gallery thumbnails
    // ============================
    var thumbs = document.querySelectorAll('.gallery-thumb');
    var slides = document.querySelectorAll('.gallery-slide');

    if (thumbs.length && slides.length) {
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var idx = this.getAttribute('data-index');
          thumbs.forEach(function(t) { t.classList.remove('is-active'); });
          slides.forEach(function(s) { s.classList.remove('is-active'); });
          this.classList.add('is-active');
          var target = document.querySelector('.gallery-slide[data-index="' + idx + '"]');
          if (target) target.classList.add('is-active');
        });
      });
    }

    // ============================
    // Product Variation Swatches
    // ============================
    var swatchContainer = document.querySelector('.product-variation-swatches');
    if (swatchContainer) {
      var productSelect = document.getElementById('product-select');
      var addToCartBtn = document.querySelector('.add-to-cart-btn');
      var variants = window.luxProductVariants || [];

      document.querySelectorAll('.swatch-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var group = this.closest('.swatch-group');
          group.querySelectorAll('.swatch-btn').forEach(function(b) { b.classList.remove('is-active'); });
          this.classList.add('is-active');
          var label = group.querySelector('.swatch-selected-value');
          if (label) label.textContent = this.getAttribute('title') || this.textContent.trim();
          matchVariant();
        });
      });

      function getSelectedOptions() {
        var opts = [];
        document.querySelectorAll('.swatch-group').forEach(function(group) {
          var active = group.querySelector('.swatch-btn.is-active');
          opts.push(active ? (active.getAttribute('data-value') || active.textContent.trim()) : null);
        });
        return opts;
      }

      function matchVariant() {
        var selected = getSelectedOptions();
        var matched = null;

        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var isMatch = true;
          for (var j = 0; j < selected.length; j++) {
            if (selected[j] && v['option' + (j + 1)] !== selected[j]) {
              isMatch = false;
              break;
            }
          }
          if (isMatch) { matched = v; break; }
        }

        if (matched) {
          if (productSelect) productSelect.value = matched.id;
          var priceEl = document.querySelector('.product-price-wrap .price');
          if (priceEl && matched.price) {
            priceEl.innerHTML = (matched.compare_at_price > matched.price
              ? '<del>' + formatMoney(matched.compare_at_price) + '</del> <ins>' + formatMoney(matched.price) + '</ins>'
              : formatMoney(matched.price));
          }
          if (matched.featured_image) {
            var matchedSrc = matched.featured_image.src;
            var foundSlide = false;
            var allSlides = document.querySelectorAll('.gallery-slide');
            var allThumbs = document.querySelectorAll('.gallery-thumb');

            allSlides.forEach(function(slide, idx) {
              var slideImg = slide.querySelector('img');
              if (slideImg && matchedSrc) {
                var slideName = slideImg.src.split('?')[0].split('/').pop();
                var matchName = matchedSrc.split('?')[0].split('/').pop();
                if (slideName === matchName || slideImg.src === matchedSrc) {
                  allSlides.forEach(function(s) { s.classList.remove('is-active'); });
                  allThumbs.forEach(function(t) { t.classList.remove('is-active'); });
                  slide.classList.add('is-active');
                  var matchingThumb = document.querySelector('.gallery-thumb[data-index="' + idx + '"]');
                  if (matchingThumb) matchingThumb.classList.add('is-active');
                  foundSlide = true;
                }
              }
            });

            if (!foundSlide) {
              allSlides.forEach(function(s) { s.classList.remove('is-active'); });
              allThumbs.forEach(function(t) { t.classList.remove('is-active'); });
              var firstSlide = document.querySelector('.gallery-slide[data-index="0"]');
              var firstThumb = document.querySelector('.gallery-thumb[data-index="0"]');
              if (firstSlide) {
                firstSlide.classList.add('is-active');
                var firstImg = firstSlide.querySelector('img');
                if (firstImg) firstImg.src = matchedSrc;
              }
              if (firstThumb) firstThumb.classList.add('is-active');
            }
          }
          if (addToCartBtn) {
            if (matched.available) {
              addToCartBtn.disabled = false;
              addToCartBtn.textContent = 'Add to Cart';
            } else {
              addToCartBtn.disabled = true;
              addToCartBtn.textContent = 'Sold Out';
            }
          }
        }
      }
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    // ============================
    // Quantity +/- buttons
    // ============================
    document.querySelectorAll('.qty-minus, .qty-btn.qty-minus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.parentNode.querySelector('input[type="number"]');
        var val = parseInt(input.value, 10) || 1;
        if (val > 1) input.value = val - 1;
      });
    });
    document.querySelectorAll('.qty-plus, .qty-btn.qty-plus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.parentNode.querySelector('input[type="number"]');
        var val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
      });
    });

    // ============================
    // Product Tabs
    // ============================
    document.querySelectorAll('.product-tabs-nav a').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var tabId = this.getAttribute('data-tab');
        document.querySelectorAll('.product-tabs-nav li').forEach(function(li) { li.classList.remove('is-active'); });
        document.querySelectorAll('.product-tab-panel').forEach(function(p) { p.classList.remove('is-active'); });
        this.parentNode.classList.add('is-active');
        var panel = document.getElementById('tab-' + tabId);
        if (panel) panel.classList.add('is-active');
      });
    });

    // ============================
    // Wishlist
    // ============================
    function getWishlist() { return JSON.parse(localStorage.getItem('lux_wishlist') || '[]'); }
    function saveWishlist(wl) { localStorage.setItem('lux_wishlist', JSON.stringify(wl)); updateWishlistUI(); }

    function updateWishlistUI() {
      var wl = getWishlist();
      document.querySelectorAll('.wishlist-count').forEach(function(el) {
        if (wl.length > 0) { el.textContent = wl.length; el.style.display = ''; }
        else { el.style.display = 'none'; }
      });
      document.querySelectorAll('.wishlist-toggle').forEach(function(btn) {
        var id = String(btn.getAttribute('data-product-id'));
        var inList = wl.some(function(w) { return String(w.id) === id; });
        if (inList) {
          btn.classList.add('is-wishlisted');
          btn.querySelector('svg').setAttribute('fill', 'currentColor');
        } else {
          btn.classList.remove('is-wishlisted');
          btn.querySelector('svg').setAttribute('fill', 'none');
        }
      });
    }
    updateWishlistUI();
    window.addEventListener('wishlist-updated', updateWishlistUI);

    window.toggleWishlist = function(btn) {
      var id = String(btn.getAttribute('data-product-id'));
      var wl = getWishlist();
      var exists = wl.some(function(w) { return String(w.id) === id; });
      if (exists) {
        wl = wl.filter(function(w) { return String(w.id) !== id; });
      } else {
        wl.push({
          id: id,
          title: btn.getAttribute('data-product-title') || '',
          price: btn.getAttribute('data-product-price') || '',
          image: btn.getAttribute('data-product-image') || '',
          url: btn.getAttribute('data-product-url') || '',
          vendor: btn.getAttribute('data-product-vendor') || ''
        });
      }
      saveWishlist(wl);
    };

    // ============================
    // Intersection Observer for animations
    // ============================
    var animElements = document.querySelectorAll('.category-card, .product-card, .collection-card, .approach-card, .post-card, .fade-in-up, .testimonial-card, .value-card, .image-text-media, .image-text-content');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            if (entry.target.classList.contains('fade-in-up')) entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      animElements.forEach(function(el) {
        if (!el.classList.contains('fade-in-up')) {
          el.style.opacity = '0';
          el.style.transform = 'translateY(20px)';
          el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        }
        observer.observe(el);
      });
    }

    // ============================
    // Cart quantity updates (cart page)
    // ============================
    document.querySelectorAll('.cart-qty').forEach(function(input) {
      input.addEventListener('change', function() {
        var line = this.getAttribute('data-line');
        var qty = parseInt(this.value) || 0;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(line), quantity: qty })
        }).then(function() { window.location.reload(); });
      });
    });

    // ============================
    // Back to Top
    // ============================
    var backToTop = document.getElementById('back-to-top');
    if (backToTop) {
      window.addEventListener('scroll', function() {
        if (window.scrollY > 400) {
          backToTop.classList.add('is-visible');
        } else {
          backToTop.classList.remove('is-visible');
        }
      });
      backToTop.addEventListener('click', function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    // ============================
    // Size Guide Modal
    // ============================
    var sizeGuideOverlay = document.getElementById('size-guide-overlay');
    var sizeGuideModal = document.getElementById('size-guide-modal');
    var sizeGuideClose = document.getElementById('size-guide-close');

    function openSizeGuide() {
      if (sizeGuideOverlay) sizeGuideOverlay.style.display = '';
      if (sizeGuideModal) sizeGuideModal.style.display = '';
    }
    function closeSizeGuide() {
      if (sizeGuideOverlay) sizeGuideOverlay.style.display = 'none';
      if (sizeGuideModal) sizeGuideModal.style.display = 'none';
    }

    document.querySelectorAll('.size-guide-link').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        openSizeGuide();
      });
    });
    if (sizeGuideClose) sizeGuideClose.addEventListener('click', closeSizeGuide);
    if (sizeGuideOverlay) sizeGuideOverlay.addEventListener('click', closeSizeGuide);

    // ============================
    // Recently Viewed Products
    // ============================
    if (document.querySelector('.product-single')) {
      var productId = window.location.pathname;
      var recent = JSON.parse(localStorage.getItem('lux_recently_viewed') || '[]');
      if (recent.indexOf(productId) === -1) {
        recent.unshift(productId);
        if (recent.length > 10) recent = recent.slice(0, 10);
        localStorage.setItem('lux_recently_viewed', JSON.stringify(recent));
      }
    }

  });

  // Mobile nav styles (injected for old navigation fallback)
  var style = document.createElement('style');
  style.textContent = '@media(max-width:768px){.main-navigation.is-open{display:block;position:fixed;top:60px;left:0;right:0;bottom:0;background:#fff;z-index:999;padding:20px;overflow-y:auto}.main-navigation.is-open .menu{flex-direction:column;gap:0}.main-navigation.is-open .menu li a{padding:16px 0;font-size:1.1rem;border-bottom:1px solid #e5e7eb}}';
  document.head.appendChild(style);
})();
